import Vuex from 'vuex'
import Vue from 'vue'
import api from './Api'
Vue.config.devtools = true // to show in chrome

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shiftNum: 0
  },
  mutations: {
    updateShiftNum (state, id) {
      state.shiftNum = id
    }
  },
  modules: {
    api
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js